import { render, staticRenderFns } from "./PieEchart2.vue?vue&type=template&id=1a0f85dc&scoped=true&"
import script from "./PieEchart2.vue?vue&type=script&lang=js&"
export * from "./PieEchart2.vue?vue&type=script&lang=js&"
import style0 from "./PieEchart2.vue?vue&type=style&index=0&id=1a0f85dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0f85dc",
  null
  
)

export default component.exports